export default __webpack_public_path__ + "static/media/mobile_before_session.394bae01.png";